// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-status-banner {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10030;
  width: min(700px, calc(100vw - 32px));
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 18px;
  min-height: 56px;
  border-radius: 14px;
  background: rgba(87, 87, 87, 0.96);
  color: #fff;
  box-shadow: 0 16px 44px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(10px);
}

.network-status-banner__content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 auto;
  min-width: 0;
}

.network-status-banner__dot {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  border-radius: 50%;
  background: #ff3b30;
  box-shadow: 0 0 0 4px rgba(255, 59, 48, 0.18);
}

.network-status-banner--online .network-status-banner__dot {
  background: #28c76f;
  box-shadow: 0 0 0 4px rgba(40, 199, 111, 0.18);
}

.network-status-banner__message {
  font-size: 0.92rem;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: -0.01em;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.network-status-banner__action-slot {
  flex: 0 0 168px;
  width: 168px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-self: stretch;
}

.network-status-banner__action-slot--placeholder {
  visibility: hidden;
}

.network-status-banner__action {
  border: 0;
  border-radius: 10px;
  background: #e15f6d;
  color: #fff;
  width: 100%;
  min-height: 36px;
  padding: 7px 18px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, opacity 0.2s ease;
}

.network-status-banner__action:hover:not(:disabled) {
  background: #d64a59;
}

.network-status-banner__action:disabled {
  cursor: default;
  opacity: 0.72;
}

@media (max-width: 700px) {
  .network-status-banner {
    top: 12px;
    width: calc(100vw - 24px);
    min-height: 0;
    padding: 10px 14px;
    align-items: stretch;
    flex-direction: column;
  }

  .network-status-banner__action-slot {
    flex: none;
    width: 100%;
  }

  .network-status-banner__action-slot--placeholder {
    display: none;
  }

  .network-status-banner__action {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/NetworkStatusBanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE;IACE,SAAS;IACT,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".network-status-banner {\n  position: fixed;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10030;\n  width: min(700px, calc(100vw - 32px));\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 10px 18px;\n  min-height: 56px;\n  border-radius: 14px;\n  background: rgba(87, 87, 87, 0.96);\n  color: #fff;\n  box-shadow: 0 16px 44px rgba(0, 0, 0, 0.28);\n  backdrop-filter: blur(10px);\n}\n\n.network-status-banner__content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.network-status-banner__dot {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  border-radius: 50%;\n  background: #ff3b30;\n  box-shadow: 0 0 0 4px rgba(255, 59, 48, 0.18);\n}\n\n.network-status-banner--online .network-status-banner__dot {\n  background: #28c76f;\n  box-shadow: 0 0 0 4px rgba(40, 199, 111, 0.18);\n}\n\n.network-status-banner__message {\n  font-size: 0.92rem;\n  font-weight: 500;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n}\n\n.network-status-banner__action-slot {\n  flex: 0 0 168px;\n  width: 168px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  align-self: stretch;\n}\n\n.network-status-banner__action-slot--placeholder {\n  visibility: hidden;\n}\n\n.network-status-banner__action {\n  border: 0;\n  border-radius: 10px;\n  background: #e15f6d;\n  color: #fff;\n  width: 100%;\n  min-height: 36px;\n  padding: 7px 18px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease, opacity 0.2s ease;\n}\n\n.network-status-banner__action:hover:not(:disabled) {\n  background: #d64a59;\n}\n\n.network-status-banner__action:disabled {\n  cursor: default;\n  opacity: 0.72;\n}\n\n@media (max-width: 700px) {\n  .network-status-banner {\n    top: 12px;\n    width: calc(100vw - 24px);\n    min-height: 0;\n    padding: 10px 14px;\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .network-status-banner__action-slot {\n    flex: none;\n    width: 100%;\n  }\n\n  .network-status-banner__action-slot--placeholder {\n    display: none;\n  }\n\n  .network-status-banner__action {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
